import type { Scene } from "@babylonjs/core/scene";
import type { DirectionalLight } from "@babylonjs/core/Lights/directionalLight";
import type { FreeCamera } from "@babylonjs/core/Cameras/freeCamera";

/** Keep contact depth and texel density around the shipping view. This is
 * presentation only: neither the camera nor any simulation root is moved. */
export function installCanopyShadowView(scene: Scene, key: DirectionalLight,
  camera: FreeCamera): () => void {
  const prior = { position: key.position.clone(), min: key.shadowMinZ,
    max: key.shadowMaxZ, size: key.shadowFrustumSize };
  const direction = key.direction.normalizeToNew();
  const update = (): void => {
    const target = camera.getTarget();
    const snap = (n: number): number => Math.round(n * 64) / 64;
    key.position.set(snap(camera.position.x - direction.x * 30),
      snap(target.y - direction.y * 30), -direction.z * 30);
    key.shadowMinZ = .1; key.shadowMaxZ = 80;
    const viewWidth = 2 * Math.abs(camera.position.z) * Math.tan(camera.fov / 2)
      * scene.getEngine().getAspectRatio(camera);
    key.shadowFrustumSize = Math.max(32, viewWidth + 4);
  };
  update();
  const render = scene.onBeforeRenderObservable.add(update);
  const end = scene.onDisposeObservable.add(() => dispose());
  let retired = false;
  const dispose = (): void => {
    if (retired) return;
    retired = true;
    scene.onBeforeRenderObservable.remove(render);
    scene.onDisposeObservable.remove(end);
    if (!key.isDisposed()) {
      key.position.copyFrom(prior.position); key.shadowMinZ = prior.min;
      key.shadowMaxZ = prior.max; key.shadowFrustumSize = prior.size;
    }
  };
  return dispose;
}
